import * as React from 'react';

function SvgSorted(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1H2a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V2a1 1 0 00-1-1zM2 0a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2z"
        fill={props.color}
      />
      <path
        d="M8.369 10.77a.477.477 0 01-.738 0L4.514 7.047c-.276-.33-.052-.845.369-.845h6.234c.42 0 .646.515.37.845L8.368 10.77z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgSorted;
